 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		116: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"default~admin-panel~a~7ec207d5","1":"vendors~admin-panel~a~5d1f16ab","2":"router-error-layout","3":"vendors~admin-panel~a~ac046c64","4":"vendors~admin-panel-r~a80638c8","5":"vendors~admin-panel-r~2d3f9aff","6":"default~app-developer~06ac6a17","7":"vendors~admin-panel-r~572d67e2","8":"default~app-layout~au~65620825","9":"vendors~app-layout~au~3dcd327a","10":"default~app-developer~2491f017","11":"default~app-developer~9a22a66a","12":"default~app-developer~fa0d8cfc","13":"vendors~app-layout~au~bed47eda","14":"default~app-layout~au~90747b74","15":"vendors~app-layout~au~a46ccca0","16":"default~app-layout~au~9d0b3661","17":"vendors~auth-login~au~17998cfa","18":"vendors~auth-login~au~a274b8dc","19":"default~auth-login~au~fff7c867","20":"vendors~app-layout~au~6bc80ff5","21":"default~app-layout~au~b9b91dfc","22":"default~book-purchase~37029e2a","23":"default~app-layout~bo~f6b7bbfa","24":"default~join~join-pay~f14d2b9b","25":"vendors~join~join-pay~8b414940","26":"default~auth-signup~b~2b8b44b8","27":"vendors~auth-signup~b~b976ab14","28":"default~auth-login~ho~69edaa01","29":"vendors~admin-panel-r~e4291acf","30":"default~collections~c~0d900781","31":"vendors~auth-welcome~~1947368f","32":"vendors~collections~c~4042232f","33":"default~auth-welcome~~77c44a96","34":"default~auth-welcome~~bdedcc7d","35":"default~collection~co~06aa196d","36":"vendors~auth-welcome~~56be291d","37":"default~collection~co~0fbe3df2","38":"vendors~collection-ne~b5b701d7","39":"default~alacarte-payw~7e1d56bc","40":"default~collection~fa~466bb45c","41":"vendors~admin-panel~a~65924968","42":"vendors~comments~noti~13a12f38","43":"default~app-layout~se~4479bbbd","44":"default~app-settings~~a968ffef","45":"default~auth-reset~web-reset","46":"default~auth-welcome~home","47":"default~book~content","48":"default~book~person","49":"default~notifications~a117e69d","50":"default~subscribe~sub~f7775a34","51":"default~user-settings~616e3fbb","52":"default~user-settings~9786616c","53":"vendors~admin-panel-r~428d7511","54":"vendors~app-developer~content","55":"vendors~auth-welcome~home","56":"vendors~book~person","57":"vendors~notifications~30618429","58":"vendors~user-settings~6217d7e4","59":"vendors~user-settings~edf3d118","60":"access-check-error-paywall","61":"account-on-hold-paywall","62":"admin-panel","63":"admin-panel-impersonate","64":"admin-panel-review-images","65":"admin-panel-ruok","66":"alacarte-debug-prices","67":"alacarte-paywall","69":"app-developer","70":"app-layout","71":"app-settings","72":"app-subscription-plan-chooser","73":"auth-login","74":"auth-reset","75":"auth-signup","76":"auth-welcome","77":"blog","78":"blogs","79":"book","80":"book-purchase","81":"books","82":"bsh-asssted-cooking","83":"collection","84":"collection-confirm-deletion","85":"collection-edit","86":"collection-new","87":"collection-unsaved-changes","88":"collections","89":"comments","90":"content","91":"embed","92":"embed-dialog","94":"favourites","95":"groceries-redirect","96":"home","97":"home-collection","98":"home-connect-menu","99":"homeconnect-claim","100":"i-cooked-this","101":"in-app-payment","102":"join","103":"join-paywall","104":"metered-access-banner","105":"not-found","106":"notifications-menu","107":"onboarding","108":"onboarding-asked","109":"onboarding-preferences","110":"onboarding-reset","111":"person","112":"premium","113":"rate-us","117":"search","118":"search-results","119":"subscribe","120":"subscribe-dialog","121":"table-of-contents","122":"unsubscribe","123":"upgrade-paywall","124":"user-membership","125":"user-membership-admin","126":"user-notifications","127":"user-settings","128":"user-settings-appearance","129":"user-settings-groceries","130":"user-settings-interests","131":"user-settings-notifications","132":"user-settings-nutrition","133":"user-settings-search","134":"user-settings-smartkitchen","135":"user-settings-units","136":"vendors~admin-panel-ruok","137":"vendors~admin-panel-r~70b77485","138":"vendors~alacarte-paywall","139":"vendors~app-developer","140":"vendors~app-settings","141":"vendors~auth-login","142":"vendors~blog","143":"vendors~blogs","144":"vendors~book-purchase","145":"vendors~books","146":"vendors~collections","147":"vendors~content","148":"vendors~metered-access-banner","149":"vendors~table-of-contents","150":"vendors~user-membership","151":"vendors~user-settings~f42fa2ed","152":"vendors~videos","153":"videos","154":"voucher-claim","155":"voucher-pending-paywall","157":"web-login","158":"web-login-changeuser","159":"web-reset","160":"web-signup"}[chunkId]||chunkId) + "." + {"0":"59ed3de3","1":"bcda66ad","2":"53a2cd00","3":"7e8a244f","4":"a743d566","5":"e328d5aa","6":"cf4f3222","7":"267533ed","8":"0ac2ecf0","9":"e065a846","10":"6e9e9241","11":"7cfab0c2","12":"2939722c","13":"34715e42","14":"ce28ff0f","15":"f6801819","16":"756125a9","17":"251ef4a8","18":"d8dc8d29","19":"2442b400","20":"f01ec7a2","21":"63e99ec6","22":"45327d2d","23":"dd8e2aa6","24":"a51351aa","25":"35a072fc","26":"6989690f","27":"1318c43e","28":"94f8a49e","29":"10b898dc","30":"619b69f1","31":"b4e4ba41","32":"01d1dcf6","33":"3eafbdba","34":"077c6887","35":"766d2545","36":"9f2c352c","37":"8de811c4","38":"c1139040","39":"f2199495","40":"0ec52e53","41":"d686b801","42":"0fea8e84","43":"0fb17343","44":"fc95a45d","45":"7e0d7f3e","46":"f0f94507","47":"64905272","48":"e0d62673","49":"416954b1","50":"1ff5aae4","51":"c06d2680","52":"5eaf06ff","53":"d0f7d381","54":"21997d8d","55":"864bff67","56":"bd267ab4","57":"333d1864","58":"42160b06","59":"b4525656","60":"32997929","61":"9ffb74a2","62":"d834a10e","63":"97c8097a","64":"2b55dcb0","65":"cf74da79","66":"623f5923","67":"5aa2498e","69":"f9cd6384","70":"5bde6ff8","71":"8dca4383","72":"e2c142b3","73":"d249b337","74":"47c86525","75":"5b92452c","76":"1c61645d","77":"117c6c01","78":"a06373f9","79":"eadfa0bd","80":"12c203df","81":"2f2f2540","82":"9107c05f","83":"83b39870","84":"2d9c5149","85":"5dddc0cd","86":"681bc8e8","87":"5d898cdc","88":"5115e834","89":"75bf9ee7","90":"71993cd5","91":"d4934eb4","92":"8eaed61e","94":"eb7af399","95":"d92e532d","96":"6c33e02d","97":"84fbc969","98":"fdb9b4d8","99":"58db8a54","100":"ac708959","101":"5701e947","102":"d8b33f1c","103":"0631bcf2","104":"361b31dc","105":"b9b33f4f","106":"1e223aab","107":"67a0fed3","108":"1bf8e0a9","109":"f8596d21","110":"84772ede","111":"ae875a67","112":"9d4463be","113":"d6fdd1d7","117":"7eaaa8bb","118":"f694831b","119":"3748722c","120":"5bd52e65","121":"a0c4b6eb","122":"0c119993","123":"55f5c156","124":"a6192914","125":"16c2624f","126":"01d1c02d","127":"5ad58ada","128":"0bec648f","129":"bcb6f4dc","130":"e87e3e3b","131":"586917f6","132":"f8c19cb3","133":"2001e916","134":"4b350da7","135":"494c8e5b","136":"ea726c56","137":"666b2b23","138":"c02acf96","139":"7c3e8e70","140":"8e5b21f0","141":"3f1d838e","142":"9aa1c426","143":"d419ad1a","144":"20cc1bf0","145":"152d917c","146":"42531618","147":"831fec5a","148":"7aee0f10","149":"f0a17486","150":"3ded4a65","151":"e0805dfd","152":"f72247fd","153":"1ba56c31","154":"d77bcacd","155":"43252e26","157":"8e244f54","158":"b4ddf4a8","159":"2f36acac","160":"9b5cc613"}[chunkId] + ".chunk.legacy.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
